import { useEffect, useRef } from 'react';

import { supabase } from '../lib/supabase.js';

// ---------------------------------------------------------------------------
// Subscribe to Realtime updates on a single discord_connections row.
//
// The Realtime channel is keyed by the connection id so subscribing on a
// stable identity (rather than the whole row object) avoids tearing the
// channel down and rebuilding it on every refetch. The publication is
// column-filtered in migration 0011 so token columns never reach this
// callback.
//
// onChange is captured in a ref so a new closure on every render does
// NOT re-create the channel - the dep is connectionId only.
// ---------------------------------------------------------------------------

export function useDiscordConnectionRealtime(
  connectionId: string | null,
  onChange: () => void,
): void {
  const onChangeRef = useRef(onChange);
  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    if (connectionId === null) return undefined;
    const channel = supabase.channel(`discord-connection:${connectionId}`);
    channel
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'discord_connections',
          filter: `id=eq.${connectionId}`,
        },
        () => onChangeRef.current(),
      )
      .subscribe();
    return () => {
      void channel.unsubscribe();
    };
  }, [connectionId]);
}
